import { Box } from "@mui/material";
import { GraphVariateSelector } from "../components/GraphVariateSelector";

type Props = {
  chartViewMode: "individual" | "combined";
  setChartViewMode: React.Dispatch<
    React.SetStateAction<"individual" | "combined">
  >;
};

function GraphVariateConfigRow({ chartViewMode, setChartViewMode }: Props) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <GraphVariateSelector
        chartViewMode={chartViewMode}
        setChartViewMode={setChartViewMode}
      />
    </Box>
  );
}

export { GraphVariateConfigRow };
